import { useEffect, useRef, useState } from 'react';
import styles from './GoalsList.module.scss';
import GoalItem from './GoalsBlock/GoalItem';
import AddGoal from './AddGoal';

export default function GoalsList({
  goals = [],
  onDeleted,
  onUpdated,
  onAddGoal,
}) {
  const [activeId, setActiveId] = useState(null);
  const activeIdRef = useRef(null);
  const listRef = useRef(null);

  useEffect(() => {
    activeIdRef.current = activeId;
  }, [activeId]);

  useEffect(() => {
    const onDocClickCapture = (e) => {
      if (activeIdRef.current == null) return;

      if (e.target.closest('button, a, input, textarea, select, label')) return;

      const cardEl = e.target.closest('[data-goal-card="1"]');
      const clickedId = cardEl ? Number(cardEl.dataset.goalId) : null;

      if (cardEl) {
        setActiveId(null);
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      setActiveId(null);
    };

    document.addEventListener('click', onDocClickCapture, true);
    return () => document.removeEventListener('click', onDocClickCapture, true);
  }, []);

  const onToggle = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
  };

  const handleDeletedLocal = (id) => {
    onDeleted?.(id);
    setActiveId((prev) => (prev === id ? null : prev));
  };

  const handleUpdatedLocal = (updatedGoal) => {
    onUpdated?.(updatedGoal);

    const id = updatedGoal?.id;
    if (!Number.isFinite(Number(id))) return;

    setActiveId((prev) => (prev === id ? null : prev));
  };

  return (
    <div
      ref={listRef}
      className={[
        styles.goalsList,
        activeId !== null ? styles['goalsList--hasActive'] : '',
      ].join(' ')}>
      {goals.length === 0 ? (
        <div className={styles.goalsList__empty}>
          <p className={styles.goalsList__emptyText}>
            Пока нет целей.
            <br />
            Нажмите на кнопку выше, что бы добавить первую.
          </p>
        </div>
      ) : (
        goals.map((goal) => (
          <div key={goal.id} data-goal-card='1' data-goal-id={goal.id}>
            <GoalItem
              goal={goal}
              active={activeId === goal.id}
              onToggle={() => onToggle(goal.id)}
              onDeleted={handleDeletedLocal}
              onUpdated={handleUpdatedLocal}
            />
          </div>
        ))
      )}

      {goals.length > 0 && (
        <AddGoal
          onCreated={onAddGoal}
          renderTrigger={(openModal) => (
            <div
              className={styles.ghostCard}
              onClick={openModal}
              role='button'
              tabIndex={0}>
              <div className={styles.ghostCard__inner}>
                <svg
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'>
                  <line x1='12' y1='5' x2='12' y2='19'></line>
                  <line x1='5' y1='12' x2='19' y2='12'></line>
                </svg>
                <span>Новая цель</span>
              </div>
            </div>
          )}
        />
      )}
    </div>
  );
}
